import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ConstantsService } from '../common/services/constants.service';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json;charset=utf-8', 
        'Authorization': ConstantsService.AUTH_TOKEN
    })    
};

@Injectable()
export class GeocodeService {
  private locationIqKey = 'pk.4a617af0a253ed91a23aa1e59377f791';
  private openCageKey = '49857fe06c444d1991c4dd7575a82ba0';

  constructor(private http: HttpClient) {}

  getAddress(lat: number, lon: number) {
    const locationIqUrl = `https://us1.locationiq.com/v1/reverse.php?key=${this.locationIqKey}&lat=${lat}&lon=${lon}&format=json`;
    //const openCageUrl = `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lon}&key=${this.openCageKey}`
    return this.http.get(locationIqUrl).pipe(
      catchError(error => {
        //console.warn('LocationIQ failed, falling back to OpenCage');
        const openCageUrl = `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lon}&key=${this.openCageKey}`;
        return this.http.get(openCageUrl);
      })
    );
  }
}
